import { Flex, Icon } from "@chakra-ui/react";
import { MdAutoAwesome, MdCheckCircle } from "react-icons/md";

type Props = {
  isCompleted: boolean;
};

export default function StatusIcon({ isCompleted }: Props) {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      boxSize={9}
      borderRadius="lg"
      background={isCompleted ? "green.500" : "pink.500"}
      color="white"
      flexShrink={0}
    >
      <Icon as={isCompleted ? MdCheckCircle : MdAutoAwesome} boxSize={5} />
    </Flex>
  );
}
